// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G80N","buttons":"styles_buttons__3Xc2_"};